export enum Environment {
    DEV = 1,
    TEST = 2,
    UAT = 3,
    PROD = 4
}